// Set up your application entry point here...
require("../node_modules/bootstrap-datepicker/dist/css/bootstrap-datepicker3.css");
require("../node_modules/select2/dist/css/select2.css");
require("./styles/global_styles");
import "./constants";
import "babel-polyfill";
// export it to the window, so ricochet dev's can use it too,
// and will not affect us
import moment from "moment";
window.moment = moment;

import $ from "jquery";
import blockUI from 'block-ui';
import "./lib/bootstrap";
import "./lib/jquery.dotdotdot";
import "bootstrap-colorpicker";
// Remove Dependency in future, only using inputmask
// import "./lib/jasny-bootstrap";
import "tableexport";
import "jquery.inputmask";
import 'inputmask.numeric.extensions';

import _ from "underscore";
import "./utilities/underscoreMixins";
import "jquery-validation";
// we have to specially import this file because it incorrectly
// references a variable in the main package, so we fix it
import "./lib/jquery-validation/additional-methods";
import "./utilities/jqueryValidationMethods";

$.validator.addClassRules("isrequired", {required: true});

import "./lib/jquery.caret";
import "jquery-deparam";

// this is generated from an alias in webpack configs
require("configuredDataTables");
// import "./lib/dataTables";

import "typeahead.js";
import "select2";
import "bootstrap-datepicker";

// load all store data from data attributes first
import "./utilities/loadJsStoreData";

import "./pages/order/index";
import "./pages/asns/index";
import "./pages/products/index";
import "./pages/createChannel/index";
import "./pages/createRule/index";
import "./pages/shipmentTracking/index";
import "./pages/orderpackaging/index";
import "./pages/inventory/index";
import "./pages/report/index";
import "./pages/hcu/hcuTopNav/index";
import "./pages/hcu/hcuGlossary/index";
import "./pages/hcu/hcuFAQ/index";
import "./pages/amazon/index";
import "./pages/amazon-fba-order/index";
import "./pages/workorder/index";
import "./pages/addressBook/index";
import "./pages/dockConfigurations/index";
import "./pages/webhooks/index";
import "./pages/dimdivisor/index";
import "./pages/editAppointmentScheduling/index";
import "./pages/discounts/index";

// import "./utilities/quickToggler";
// import "./utilities/quickExpander/quickExpanderTest";

import "./pages/hcu/layout";
import "./pages/hcu/login/index";
import "./pages/hcu/resetPasswordScreen/index";
import "./pages/returnRevamp/index";

// When complete, the below import will include the actual
// functionality for the hcu guides page provided by Jigar
import "./pages/hcu/guides/index";

import "./pages/hcu/hcuSearch/index";
import "./pages/rma/rmaDetails/index";
import "./pages/rma/index";
import "./pages/collateralRules/index";
import "./pages/hcu/hcuGlossaryTerm/index";
import "./pages/hcu/hcuHomepage/index";

// import "./pages/consumerReturns/consumerReturnsView/index";
import "./pages/schedulePickup/index.js"
import "./pages/teamMembers/details/index.js";
import "./pages/teamMembers/manage/index.js";
import "./pages/teamMembers/index.js";
import "./pages/appointmentForm/index.js"
import "./pages/shipmentStringMapping/index.js"
// import "./pages/hcu/hcuFAQ/index";
// import "./pages/hcu/hcuGlossary/index";

// import "./pages/ecds/index";

import "./pages/orderConfiguration/index";

// import "./pages/orderConfiguration/index";

import "./pages/orderType/index";

import "./pages/billingInformation/index";

import "./pages/notificationPreferences/index";

import "./pages/oAuth/index";

// FOR ERROR PAGE SLASH SYSTEM DOWN FOR MAINTENANCE PAGE AND MODAL
// import "./pages/systemDownMaintenance/index";

// Commerce Drawer
import "./pages/commerceDrawer/index";

import "./pages/retailer/addressSteeringLookup/index";
import "./pages/retailer/locationsLookup/index";
import "./pages/retailer/locationsDetails/index";
import "./pages/retailer/maintainLocation/index";
import "./pages/bulkShipments/index.js";
import "./pages/returnsRules/index.js";

import "./pages/merchantConfig/merchantConfigManage/index.js";
import "./pages/merchantConfig/merchantConfigView/index.js";
import "./pages/returnRequestsWizard/index.js";

import "./pages/locationMapping/index.js";

import "./pages/locations/index.js";

//HB-7172
import "./pages/facilities/index.js";

import "./pages/fedexAccountManagement/index.js";
import "./pages/maintainRetailer/index.js";
import "./pages/transferOrder/index.js";
import "./pages/fxoConfigurationForm/index.js";
import "./pages/bulkUpload/index.js";
import "./pages/notificationAlerts/index.js";
import "./pages/fxoReceivingScreen/index.js";
import "./pages/passwordGuidelines/index.js";

import "./pages/fxoReprintLabels/index.js";

import "./pages/proofOfDelivery/index.js";

import "./pages/receivingDiscrepancies/index.js";

import "./pages/rmaWebLite/index.js";

import "./pages/standardPlatformFacilitySetupWizard/index.js";

import "./pages/returnDispositionRules/index.js";

import "./pages/createDispositionRule/index.js";

import "./pages/returnDispositionDetails/index.js";

import "./pages/orderHoldRules/index.js";

import "./pages/orderHoldRuleDetails/index.js";

import "./pages/orderHoldRuleNewEdit/index.js";

import "./pages/releaseOrders/index.js";

import "./pages/shipmentStringMapping/index.js";
import "./pages/rmaMerchantSelfOnboarding/index.js";

import "./pages/fixitOrders/index.js";

//--------------------------------------------//
// PAGES
//--------------------------------------------//

// Could not find the folder
// import "./pages/addressValidationStub/addressValidationStub";

// Could not find the folder
// import "./pages/bundleDetailStub/bundleDetailStub";

// Rips out: RMSUI Portal
// import "./pages/teamMembers/details/index.js";

//--------------------------------------------//
// EMAIL TEMPLATES
//--------------------------------------------//

// Rips out: HTML el
// import "./pages/stubs/emailWorkOrderNotificationGeneric/";

// Rips out: HTML el
// import "./pages/stubs/emailTemplateWithPurpleBar/";

// Rips out HTML el
// import "./pages/stubs/ebayConnectionsEmailTemplate/";

// Rips out: HTML el
// import "./pages/stubs/suspiciousActivityEmailTemplate/";

// Rips out: HTML el
// import "./pages/stubs/emailRueLaLa/";

// Rips out: HTML el
// import "./pages/stubs/emailTemplateFxoLabel/";

// Rips out: HTML el
// import "./pages/stubs/emailTemplateSupplyChainLabel/";

// Rips out: HTML el
// import "./pages/stubs/emailPastDueInvoices/";

// Rips out: HTML el
// import "./pages/stubs/emailPastDueInvoices30Days/";

// Rips out: HTML el
// import "./pages/stubs/emailInvoicePosted/";

// Rips out: HTML el
// import "./pages/stubs/emailShopifyConnection/";

// Rips out: HTML el
// import "./pages/stubs/businessExceptionsEmailNotifications/";

// Rips out: HTML el
// import "./pages/stubs/emailPasswordExpired/";

// Rips out: HTML el
// import "./pages/stubs/emailInboundShipmentNotifications/";

// Rips out: HTML el
// import "./pages/stubs/emailMissingInternationalDocuments/";

// Rips out: HTML el
// import "./pages/stubs/emailAddressValidationPreferences/";
//--------------------------------------------//
// UTILITIES
//--------------------------------------------//

// Rips out Channel Portal
// import "./utilities/productsModalUtilities/example.js";

// Rips out Global Channel Portal
// import "./utilities/datePicker/example.js";

//--------------------------------------------//
// COMPONENTS
//--------------------------------------------//

import "./pages/dashboard/index";

// Rips out Global Components Portal
// import "./components/ProductModal/example";

// Rips out Global Components Portal
// import "./components/widgetEngine/example";

// Rips out Global Components Portal
// import "./components/lookupTable/example";

// Rips out Global Components Portal
// import "./components/timePicker/example";

// Rips out Global Components Portal
// import "./components/resourceProgress/example";

// Rips out Global Components Portal
// import "./components/SubmitModalFlow/example";

// Rips out Global Components Portal
// import "./components/ErrorModal/example";

// Rips out Global Components Portal
// import "./components/SaveThenDestroy/example";

// Rips out Global Components Portal
// import "./components/pagableComponent/example";

// Rips out Global Components Portal
// import "./components/fileUploader/example";

// Rips out Global Components Portal
// import "./components/scheduler/example";

//--------------------------------------------//
// STUBS
//--------------------------------------------//

// Rips out Global Development Portal
// import "./pages/stubs/addressValidationStub/addressValidationStub";

// Rips out Global Development Portal
// import "./pages/stubs/bundleNewStub/bundleNewStub";

// Rips out Global Development Portal
// import "./pages/stubs/workOrderDetailsRetailerStub/workOrderDetailsStub";

// Rips out Global Development Portal
// import "./pages/stubs/workOrderNewStub/workOrderNewStub";

// Rips out Global Development Portal
// import "./pages/stubs/systemDownMaintenance/systemDownMaintenanceStub";

// Rips out Global Development Portal
// import "./pages/stubs/hcuGuideStub/hcuGuideStub";

// Rips out Global Development Portal
// import "./pages/stubs/hcuFAQ/hcuFAQStub";

// Rips out Global Development Portal
// import "./pages/stubs/hcuHomepageStub/hcuHomepageStub";

// Rips out Global Development Portal
// import "./pages/stubs/hcuGlossary/hcuGlossaryStub";

// Rips out Global Development Portal
// import "./pages/stubs/hcuGlossaryTerm/hcuGlossaryTermStub";

// Rips out Global Development Portal
// import "./pages/stubs/hcuTopNavStub/hcuTopNavStub";

// Rips out Global Development Portal
// import "./pages/stubs/hcuSearchResults/hcuSearchResultsStub";

// Rips out Global Development Portal
// import "./pages/stubs/amazonFBAPalletSearchStub/amazonFBAPalletSearchStub";

// Rips out Global Development Portal
// import "./pages/stubs/amazonFBAPackageLabel/";

// Rips out Global Development Portal
// import "./pages/stubs/amazonFBAPackageLabelScan/";

// Rips out Global Development Portal
// import "./pages/stubs/amazonFBAPackageLabelPrint/";

// Rips out Global Development Portal
// import "./pages/stubs/amazonLPNInfo/amazonLPNInfoStub";

// Rips out Global Development Portal
// import "./pages/stubs/amazonLPNScan/amazonLPNScanStub";

// Rips out Global Development Portal
// import "./pages/stubs/brandingLogin/brandingLoginStub";

// Rips out Global Development Portal
// import "./pages/stubs/connectionModal/connectionModalStub";

// Rips out Global Development Portal
// import "./pages/stubs/relatedReturnsRevamp/relatedReturnsRevampStub";

// Rips out Global Development Portal
// import "./pages/stubs/bundleDetailStub/bundleDetailStub";

// Rips out Global Development Portal
// import "./pages/stubs/productCatalogBtnStub/productCatalogBtnStub";

// Rips out Global Development Portal
// import "./pages/stubs/newCollateralStub/newCollateralWizardStub";

// Rips out Global Development Portal
// import "./pages/stubs/collateralRulesStub/collateralRulesStub";

// Rips out Global Development Portal
// import "./pages/stubs/collateralDetailStub/collateralDetailStub";

// Rips out Global Development Portal
// import "./pages/stubs/inboundShipmentPalletFutureStub/inboundShipmentPalletFutureStub";

// Rips out Global Development Portal
// import "./pages/stubs/inboundShipmentParcelFutureStub/inboundShipmentParcelFutureStub";

// Rips out Global Development Portal
// import "./pages/stubs/collateralRuleDetailStub/collateralRuleDetailStub";

// Rips out Global Development Portal
// import "./pages/stubs/editOrderDocumentsSettingsStub/editOrderDocumentsSettings";

// Rips out Global Development Portal
// import "./pages/stubs/orderDocumentsSettingsStub/orderDocumentsSettings";

// Rips out Global Development Portal
// import "./pages/stubs/orderDetailPartialStub/orderDetailStub";

// Rips out Global Development Portal
// import "./pages/stubs/orderDetailStub/orderDetailStub";

// Rips out Global Development Portal
// import "./pages/stubs/productDetailStub/productDetailStub";

// Rips out Global Development Portal
// import "./pages/stubs/productDetailWizard/";

// Rips out Global Development Portal
// import "./pages/stubs/orderSplitStub/orderSplitStub"

// Rips out Global Development Portal
// import "./pages/stubs/amazonFBAConnectionsStub/amazonFBAConnectionsStub";

// Rips out Global Development Portal
// import "./pages/stubs/amazonMarketplaceConnectionsStub/amazonMarketplaceConnectionsStub"

// Rips out Global Development Portal
// import "./pages/stubs/amazonFBAOrderWizardStub/amazonFBAOrderWizardStub";

// Rips out Global Development Portal
// import "./pages/stubs/retailerWizardStub/retailerWizardStub";

// Rips out Global Development Portal
// import "./pages/stubs/retailerDetailStub/retailerDetailStub";

// Rips out Global Development Portal
// import "./pages/stubs/amazonFBAConnectionDetailStub/amazonFBAConnectionDetailStub"

// Rips out Global Development Portal
// import "./pages/stubs/amazonMarketplaceConnectionDetailStub/amazonMarketplaceConnectionDetailStub"

// Portal used may be UI-Dev portlet
// Rips out Global Development Portal
// import "./pages/stubs/reportsStub/reports";

// Rips out Global Development Portal
// import "./pages/stubs/consumerReturnsView/index.js";

// Rips out Global Development Portal
// import "./pages/stubs/billingInformation/billingInformation"

// Rips out Global Development Portal
// import "./pages/stubs/orderConfiguration/orderConfiguration";

// Rips out Global Development Portal
// import "./pages/stubs/orderConfigurationDetail/orderConfigurationDetail";

// Rips out Global Development Portal
// import "./pages/stubs/supplyChainFacilityModal/supplyChainFacilityModal";

// Rips out Global Development Portal
// import "./pages/stubs/commerceDrawer/commerceDrawerStub";

// Rips out Global Development Portal
// import "./pages/stubs/orderWizard/orderWizard";

// Rips out Global Development Portal
// import "./pages/stubs/notificationPreferences/notificationPreferences";

// Rips out Global Development Portal
// import "./pages/stubs/notificationPreferencesDetail/notificationPreferencesDetail";

// Rips out Global Development Portal
// import "./pages/stubs/commerceLeftNav/commerceLeftNav";

// Rips out Global Development Portal
// import "./pages/stubs/typeAheadExample/typeAheadExample";

// Rips out Global Development Portal
// import "./pages/stubs/asnWizard/asnWizard";

// Rips out Global Development Portal
// import "./pages/stubs/csvErrors/csvErrors";

// Rips out Global Development Portal
// import "./pages/stubs/asnDetail/asnDetail";

// Rips out Global Development Portal
// import "./pages/stubs/inventoryDetail/inventoryDetail";

// Rips out Global Development Portal
// import "./pages/stubs/teamMembers/details/index.js";

// Rips out Global Development Portal
// import "./pages/stubs/teamMembers/manage/index.js";

// Rips out Global Development Portal
// import "./pages/stubs/merchantConfig/merchantConfigManage/index.js";

// Rips out Global Development Portal
// import "./pages/stubs/merchantConfig/merchantConfigView/index.js";

// Rips out Body
// EXTRA NOTE: comment out required CSS at the top of this page to see this stub.
// import "./pages/stubs/oauthAcceptPage";

// Rips out Global Development Portal
// import "./pages/stubs/returnRequestsWizard";

// Rips out Global Development Portal
// import "./pages/stubs/returnRequestsDetails";

// Rips out Body
// EXTRA NOTE: comment out required CSS at the top of this page to see this stub.
// import "./pages/stubs/oauthLoginPage";

// Rips out Global Development Portal
// import "./pages/stubs/returnsEngineManage";

// Rips out Global Development Portal
// import "./pages/stubs/returnsEngineLookup";

// Rips out GLobal Development Portal
// import "./pages/stubs/returnsEngineDetails";

// Rips out Global Development portal
// import "./pages/stubs/returnsEngineHcDetails";

// Rips out Global Development portal
// import "./pages/stubs/returnsEngineHcManage";

// Rips out Global Development Portal
// import "./pages/stubs/transferOrderDetail";

// Rips out Global Development Portal
// import "./pages/stubs/transferOrderWizard";

// Rips out Global Development Portal
// import "./pages/stubs/fedexAccountManagement";

// Rips out Global Development Portal
// import "./pages/stubs/fedexAccountManagementForm/famf";

// Rips out Global Development Portal
// import "./pages/stubs/orderDesk/orderDesk.js";

// Rips out Global Development Portal
// import "./pages/stubs/ebayConnectionWizardStub/ebayConnectionsStub";

// Rips out Global Development Portal
// import "./pages/stubs/locationsDetailsStub/details";

// Rips out Globla Development Portal
// import "./pages/stubs/locationsManageStub/manage";

// Rips out Global Development Portal
// import "./pages/stubs/ebayConnectionDetailsStub/ebayConnectionDetailStub";

// Rips out Global Development Portal
// import "./pages/stubs/fxoConfigurationForm/";

// Rips out Global Development Portal
// import "./pages/stubs/fxoConfigurationDetails/";

// Rips out Global Development Portal
// import "./pages/stubs/bulkUploadTable";

// Rips out Global Development Portal
// import "./pages/stubs/orderCommunicationsForm/";

// Rips out Global Development Portal
// import "./pages/stubs/orderCommunicationsConfirmation/";

// Rips out Global Development Portal
// import "./pages/stubs/asnBulkUpload";

// Rips out Global Development Portal
// import "./pages/stubs/asnBulkUploadDetail/";

// Rips out Global Development Portal
// import "./pages/stubs/initialStateForLookupTables/initialStateForLookupTables";

// Rips out Global Development Portal
// import "./pages/stubs/notificationManagement/notificationManagement";

// Rips out Global Development Portal
// import "./pages/stubs/fxoReceivingScreen";

// Rips out Global Development Portal
// import "./pages/stubs/vendorManagementOrganizationFormNew";

// Rips out Global Development Portal
// import "./pages/stubs/vendorManagementOrganizationFormEdit";

// Rips out Global Development Portal
// import "./pages/stubs/vendorManagementCustomerFormNew";

// Rips out Global Development Portal
// import "./pages/stubs/vendorManagementCustomerFormEdit";

// Rips out Global Development Portal
// import "./pages/stubs/vendorManagementOrganizationDetails";

// Rips out Global Development Portal
// import "./pages/stubs/vendorManagementCustomerDetails";

// Rips out Global Development Portal
// import "./pages/stubs/purchaseOrderWizard";

// Rips out Global Development Portal
// import "./pages/stubs/purchaseOrderDetails";

// Rips out Global Development Portal
// import "./pages/stubs/orderTypeWizard";

// Rips out Global Development Portal
// import "./pages/stubs/orderTypeDetails";

// Rips out Global Development Portal
// import "./pages/stubs/passwordGuidelinesStub";

// Rips out Global Development Portal
// import "./pages/stubs/bulkUploadForOrdersNewFrameworkPartialStub";

// Rips out Global Development Portal
// import "./pages/stubs/podUserAdminForm";

// Rips out Global Development Portal
// import "./pages/stubs/podAdminUserDetails";

// Rips out Global Development Portal
// import "./pages/stubs/podPackageDetailsScreen";

// Rips out Global Development Portal
// import "./pages/stubs/podAdvancedShipmentForm";

// Rips out Global Development Portal
// import "./pages/stubs/locationMapping";

// Rips out Global Development Portal
// import "./pages/stubs/walmartConnectionWizardStub";

// Rips out Global Development Portal
// import "./pages/stubs/walmartConnectionDetailsStub";

// Rips out Global Development Portal
// import "./pages/stubs/newFacilityForm";

// Rips out Global Development Portal
// import "./pages/stubs/resetPasswordScreen";

// Rips out Global Development Portal
// import "./pages/stubs/userPreferencePage";

// Rips out Global Development Portal
// import "./pages/stubs/changePasswordScreen";

// Rips out Global Development Portal
// import "./pages/stubs/rmaEntryLiteVersionForm";

// Rips out Global Development Portal
// import "./pages/stubs/rmaEntryLiteVersionDetail";

// Rips out Global Development Portal
// import "./pages/stubs/customShippingMethodNewEdit";

// Rips out Global Development Portal
// import "./pages/stubs/customShippingMethodDetails";

// Rips out Global Development Portal
// import "./pages/stubs/standardPlatformFacilitySetupWizard";

// Rips out Global Development Portal
// import "./pages/stubs/standardPlatformFacilitySetupDetails";

// Rips out Global Development Portal
// import "./pages/stubs/returnDispositionMerchantConfigurationStub";

// Rips out Global Development Portal
// import "./pages/stubs/returnDispositionMerchantConfigurationDetailsStub";

// Rips out Global Development Portal
// import "./pages/stubs/orderClaimsNewEdit";

// Rips out Global Development Portal
// import "./pages/stubs/orderClaimsDetail";

// Rips out Global Development Portal
// import "./pages/stubs/dockConfigDetails";

// Rips out Global Development Portal
// import "./pages/stubs/dockConfigNewEdit";

// Rips out Global Development Portal
// import "./pages/stubs/dockNewEdit";

// Rips out Global Development Portal
// import "./pages/stubs/editAppointmentConfigurations";

// Rips out Global Development Portal
// import "./pages/stubs/appointmentConfigurationsView";

// Rips out Global Development Portal
// import "./pages/stubs/appointmentForm";

// Rips out Global Development Portal
// import "./pages/stubs/appointmentDetails";

// Rips out Global Development Portal
// import "./pages/stubs/shopifyWizard";

// Rips out Global Development Portal
// import "./pages/stubs/shopifyDetails";

// Rips out Global Development Portal
// import "./pages/stubs/orgTeamMemberNewEdit";

// Rips out Global Development Portal
// import "./pages/stubs/orgNewEdit";

// Rips out Global Development Portal
// import "./pages/stubs/orgDetails";

// Rips out Global Development Portal
// import "./pages/stubs/standardPlatformProductDetailsStub";

// Rips out Global Development Portal
// import "./pages/stubs/standardPlatformProductWizardStub";

// Rips out Global Development Portal
// import "./pages/stubs/crimsonOrderReleaseNewEdit";

// Rips out Global Development Portal
// import "./pages/stubs/crimsonOrderReleaseDetails";

// Rips out Global Development Portal
// import "./pages/stubs/crimsonErrorModals";

// Rips out Global Development Portal
// import "./pages/stubs/masterAccountSetupModal";

// Rips out Global Development Portal
// import "./pages/stubs/configureAppointmentsDockDetails";

// Rips out Global Development Portal
// import "./pages/stubs/configureAppointmentsDockForm";

// Rips out Global Development Portal
// import "./pages/stubs/webhookLookup";

// Rips out Global Development Portal
// import "./pages/stubs/doorLookup";

// Rips out Global Development Portal
// import "./pages/stubs/appointmentSchedulingNotSet";

// Rips out Global Development Portal
// import "./pages/stubs/appointmentSchedulingSet";

// Rips out Global Development Portal
// import "./pages/stubs/editAppointmentScheduling";

// Rips out Global Development Portal
// import "./pages/stubs/dimDivisorLookup";

// Rips out Global Development Portal
// import "./pages/stubs/newDimDivisor";

// Rips out Global Development Portal
// import "./pages/stubs/dimDivisorDetails";

// Rips out Global Development Portal
// import "./pages/stubs/discountLookup";

// Rips out Global Development Portal
// import "./pages/stubs/newDiscount";

// Rips out Global Development Portal
// import "./pages/stubs/discountDetails";

// Rips out Global Development Portal
// import "./pages/stubs/trappedOrderDetailsStub";

// Rips out Global Development Portal
// import "./pages/stubs/shipmentStringMapping";

// Rips out Global Development Portal
// import "./pages/stubs/returnsTechnologyRegistration";

// Rips out Global Development Portal
// import "./pages/stubs/selfOnboarding";

// Rips out Global Development Portal
// import "./pages/stubs/verizonVsigma";

//--------------------------------------------//

// Rips out Global Stub Portal
// import "./loadStubs";

// Rips out Global UI Component Portal
// import "./loadUiComponents";

// Rips our Global Component Portal
// import "./loadComponent";

import "./utilities/quickToggler";
import "./utilities/quickExpander";
import "./utilities/quickBtnExpander";
import "./utilities/dateRangeInputIconFocuser";
import "./utilities/modalHelpers";
import "./pages/all";


window.jqueryBundle = $;



// WEBPACK FOOTER //
// ./src/index.js